export function extractApiError(errorBody: unknown): string {
  if (typeof errorBody !== "object" || errorBody === null) return ""
  const body = errorBody as Record<string, unknown>
  for (const key of ["error", "detail", "message"] as const) {
    if (typeof body[key] === "string" && body[key]) return body[key]
  }

  if (typeof body.errors === "object" && body.errors !== null) {
    const messages = Object.values(body.errors as Record<string, unknown>)
      .flatMap((value) => Array.isArray(value) ? value : [value])
      .filter((value): value is string => typeof value === "string" && value.length > 0)
    if (messages.length > 0) return messages.join(" ")
  }

  return typeof body.title === "string" ? body.title : ""
}
